<div class="grid-container padding-y-4">
  <form [formGroup]="freightQueryForm">
    <fieldset class="usa-fieldset">
      <legend class="usa-legend usa-legend--large">FRT One Time Only Shipment Request</legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="requestDateTime" class="usa-label">Bid Requested By<abbr title="required"
                                                                               class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="requestDateTime" [minDate]="minDate" [maxDate]="maxDate" formControlName="requestDateTime"
                 class="usa-input" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                 placeholder="MM/dd/yyyy" bsDatepicker>
          @if (this.freightQueryForm.get('requestDateTime').touched && this.freightQueryForm.get('requestDateTime').hasError('required')) {
            <div class="text-danger"
            >
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
              Pick-Up Date is required
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="type" class="usa-label">Expedited FRT Shipment?<abbr title="required"
                                                                           class="usa-hint usa-hint--required">*</abbr></label>
          <select id="type" formControlName="expediteFreightShipment" class="usa-select">
            <option [ngValue]="'yes'">Yes</option>
            <option [ngValue]="'no'" selected>No</option>
          </select>
          @if (this.freightQueryForm.get('expediteFreightShipment').touched && this.freightQueryForm.get('expediteFreightShipment').hasError('required')) {
            <div class="text-danger"
            >
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
              This field is required
            </div>
          }
        </div>
      </div>
      <div class="grid-row grid-gap">
        <legend class="usa-legend usa-legend--medium">Shipper Information</legend>
      </div>
      <hr>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="shipper" class="usa-label">Shipper : <abbr title="required"
                                                                 class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="shipper" required class="usa-input" formControlName="shipper" size='250'
                 maxlength='250'>
          @if (this.freightQueryForm.get('shipper').invalid && (this.freightQueryForm.get('shipper').touched || this.freightQueryForm.get('shipper').dirty) && this.freightQueryForm.get('shipper').errors.required) {
            <div class="alert"
            >
              <small class="text-danger">
                <span class="fa fa-warning"></span> This field is required
              </small>
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="shipper" class="usa-label">Customer : <abbr title="required"
                                                                  class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="customer" required class="usa-input" formControlName="customer" size='250'
                 maxlength='250'>
          @if (this.freightQueryForm.get('customer').invalid && (this.freightQueryForm.get('customer').touched || this.freightQueryForm.get('customer').dirty) && this.freightQueryForm.get('customer').errors.required) {
            <div class="alert"
            >
              <small class="text-danger">
                <span class="fa fa-warning"></span> This field is required
              </small>
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="shipperEmail" class="usa-label">Email<abbr title="required"
                                                                 class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="shipperEmail" required class="usa-input" formControlName="shipperEmail" size='250'
                 maxlength='250'>
          @if (this.freightQueryForm.get('shipperEmail').invalid && (this.freightQueryForm.get('shipperEmail').touched || this.freightQueryForm.get('shipperEmail').dirty) && this.freightQueryForm.get('shipperEmail').errors.required) {
            <div class="alert"
            >
              <small class="text-danger">
                <span class="fa fa-warning"></span> Email address is required
              </small>
            </div>
          }
          @if (this.freightQueryForm.get('shipperEmail').invalid && (this.freightQueryForm.get('shipperEmail').touched || this.freightQueryForm.get('shipperEmail').dirty) && this.freightQueryForm.get('shipperEmail').errors.email) {
            <div class="alert"
            >
              <small class="text-danger">
                <span class="fa fa-warning"></span> Email Address is invalid
              </small>
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="shipperPhone" class="usa-label">Phone: <abbr title="required"
                                                                   class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="shipperPhone" class="usa-input" formControlName="shipperPhone" size='20' minLength='10'
                 maxlength='20' appNumbersOnly>
          @if (this.freightQueryForm.get('shipperPhone').invalid &&
          (this.freightQueryForm.get('shipperPhone').touched || this.freightQueryForm.get('shipperPhone').dirty) && this.freightQueryForm.get('shipperPhone').errors.numeric) {
            <div class="alert"
            >
              <small class="text-danger">
                <span class="fa fa-warning"></span> mobile Number is invalid - should be all numeric, no dashes,
                no spaces
              </small>
            </div>
          }
          @if (this.freightQueryForm.get('shipperPhone').invalid &&
          (this.freightQueryForm.get('shipperPhone').touched || this.freightQueryForm.get('shipperPhone').dirty) &&
          this.freightQueryForm.get('shipperPhone').errors.minlength) {
            <div class="alert">
              <small class="text-danger">
                <span class="fa fa-warning"></span> mobile Number should be at least 10 digits long
              </small>
            </div>
          }
        </div>
      </div>
      <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <legend class="usa-legend usa-legend--medium">Shipment Information</legend>
          <hr>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="origin_country_general" class="usa-label">Origin<abbr title="required"
                                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <select id="origin_country_general" class="usa-select" formControlName="originCountryId" [compareWith]="compareCountryFn">
            <option [ngValue]="null">..Select a Origin Country..</option>
            @for (origCountry of allCountriesFrtList$ | async; track origCountry) {
              <option [ngValue]="origCountry">{{
                  origCountry.stateCountryName }}
              </option>
            }
          </select>
          @if (isFormElementInValid('originCountryId')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Origin Country is required
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="destination_country_general" class="usa-label">Destination<abbr title="required"
                                                                                      class="usa-hint usa-hint--required">*</abbr></label>
          <select id="destination_country_general" class="usa-select" formControlName="destinationCountryId" [compareWith]="compareCountryFn">
            <option [ngValue]="null">..Select a Destination Country..</option>
            @for (country of allCountriesFrtList$ | async; track country) {
              <option [ngValue]="country">{{ country.stateCountryName }}
              </option>
            }
          </select>
          @if (isFormElementInValid('destinationCountryId')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Destination Country is required
            </div>
          }
        </div>
      </div>
      <ng-template #customItemTemplate let-model="item">{{model.cityName}} , {{model.stateAbbrev}} {{model.zipCode}} {{model.zipClassificationCode === 'P' ? 'P.O BOX ONLY' : ''}}</ng-template>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="origin" class="usa-label">Origin<abbr title="required"
                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <input id="origin" role="combobox" class="usa-input" formControlName="asyncOriginSearchString" [typeahead]="dataSourceOrigin" (typeaheadLoading)="changeTypeaheadOriginLoading($event)" (typeaheadOnSelect)="typeaheadOriginOnSelect($event)" typeaheadOptionField="cityName"
                 [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
          @if (typeaheadLoading) {
            <div class="margin-y-2 spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          }
          @if (this.freightQueryForm.get('originId').touched && this.freightQueryForm.get('originId').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Origin is required
            </div>
          }
          @if (freightQueryForm.value.originId) {
            <label class="usa-label define-bottom-tag">{{freightQueryForm.value.originId?.cityName}} , {{freightQueryForm.value.originId?.stateAbbrev}} {{freightQueryForm.value.originId?.zipCode}}</label>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" >
          <label for="destination" class="usa-label">Destination<abbr title="required"
                                                                      class="usa-hint usa-hint--required">*</abbr></label>
          <input id="destination" class="usa-input" role="combobox" formControlName="asyncDestinationSearchString" [typeaheadAsync]="true" [typeahead]="dataSourceDestination" (typeaheadLoading)="changeTypeaheadDestinationLoading($event)" (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)"
                 typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
          @if (typeaheadLoading) {
            <div class="margin-y-2 spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          }
          @if (this.freightQueryForm.get('destinationId').touched && this.freightQueryForm.get('destinationId').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Destination is required
            </div>
          }
          @if (freightQueryForm.value.destinationId) {
            <label class="usa-label define-bottom-tag">{{freightQueryForm.value.destinationId?.cityName}} , {{freightQueryForm.value.destinationId?.stateAbbrev}} {{freightQueryForm.value.destinationId?.zipCode}}</label>
          }
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-3">
          <label for="miles" class="usa-label">Mileage<abbr title="required"
                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" class="usa-input" id="miles" formControlName="estimatedMiles" name="mileage" appNumbersOnly>
          @if (this.freightQueryForm.get('estimatedMiles').touched && this.freightQueryForm.get('estimatedMiles').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Mileage is required
            </div>
          }
          @if (this.freightQueryForm.get('estimatedMiles').touched && this.freightQueryForm.get('estimatedMiles').hasError('pattern')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Mileage must be numeric
            </div>
          }
        </div>
        <div class="grid-col-3">
          <label for="estimatedWeight" class="usa-label">Weight<abbr title="required"
                                                                     class="usa-hint usa-hint--required">*</abbr>
          </label>
          <input type="text" class="usa-input" id="estimatedWeight" formControlName="estimatedWeight" (change)="onWeightCubicFtChange()" name="weight" appNumbersOnly maxlength="8">
          @if (this.freightQueryForm.get('estimatedWeight').touched && this.freightQueryForm.get('estimatedWeight').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Weight is required
            </div>
          }
          @if (this.freightQueryForm.get('estimatedWeight').touched && this.freightQueryForm.get('estimatedWeight').hasError('pattern')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Weight must be in whole numbers.
            </div>
          }
          @if (this.freightQueryForm.get('estimatedWeight').touched && (this.freightQueryForm.get('estimatedWeight').hasError('max') || this.freightQueryForm.get('estimatedWeight').hasError('min'))) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Weight must fall within range of selected Class.
            </div>
          }
          @if (showGssrError) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Only a Max of 40 lbs per Cu. Ft is allowed
            </div>
          }
        </div>
        <div class="grid-col-3">
          <label for="estimatedCuFt" class="usa-label">Total Shipment Cube (cubic ft)</label>
          <input min="0" type="text" class="usa-input" id="estimatedCuFt" formControlName="estimatedCuFt" (change)="onWeightCubicFtChange()" name="shipment" appNumbersOnly maxlength="8">
          @if (this.freightQueryForm.get('estimatedCuFt').touched && this.freightQueryForm.get('estimatedCuFt').hasError('pattern')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Total Shipment must be numeric whole numbers
            </div>
          }
          @if (showGssrError) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Only a Max of 40 lbs per Cu. Ft is allowed
            </div>
          }
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label class="usa-label" for="shipId">Agency Shipment ID No:</label>
          <input type="text" id="shipId" class="usa-input maxw-full" maxlength="18" formControlName="agencyShipmentIdNo">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label class="usa-label" for="locationCode">Agency Location Code:</label>
          <input type="text" class="usa-input maxw-full" id="locationCode" formControlName="agencyLocationCode">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label class="usa-label" for="frt-ship-val">Shipment Declared Value<abbr title="required" class="usa-hint usa-hint--required">*</abbr>:</label>
          <input type="text" class="usa-input maxw-full" placeholder="Enter Value Here" id="frt-ship-val" formControlName="declaredValue" />
          @if (this.freightQueryForm.get('declaredValue').hasError('numeric')) {
            <div class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Shipment Declared Value should be all numeric only
            </div>
          }
          @if (this.freightQueryForm.get('declaredValue').value > 100000) {
            <div class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FMP max coverage is $100,000.00. Please contact TSP and additional charges may apply.
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label class="usa-label" for="frt-ship-val">TSP Pro Bill No:</label>
          <input type="text" class="usa-input maxw-full" placeholder="Enter Value Here" id="pro-bill-val" [maxLength]="22" formControlName="tspProBillNo" />
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="pickup_date" class="usa-label">Pickup Date<abbr title="required"
                                                                      class="usa-hint usa-hint--required">*</abbr></label>
          <div class="grid-row" id="pickup_date">
            <div class="grid-col-8 mobile-lg:grid-col-8 tablet:grid-col-8 desktop:grid-col-8">
              <div class="usa-date-picker usa-date-picker--initialized" data-min-date="0000-01-01">
                <input class="usa-input usa-date-picker__internal-input" aria-labelledby="appointment-date-label"
                       aria-describedby="appointment-date-hint" aria-hidden="true" tabindex="-1" style="display: none;" >
                <div class="usa-date-picker__wrapper">
                  <input class="usa-input usa-date-picker__external-input" formControlName="moveDate"
                         id="move_date" name="move_date" aria-labelledby="move_date_label"
                         aria-describedby="move_date_hint" type="text" (change)="pickUpDateChange($event)">
                  <button type="button" class="usa-date-picker__button tmss-datepicker-custom" aria-haspopup="true"
                          aria-label="Toggle calendar"></button>
                  <div class="usa-date-picker__calendar" role="application" hidden=""></div>
                  <div class="usa-sr-only usa-date-picker__status" role="status" aria-live="polite"></div>
                </div>
              </div>
            </div>

            <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
              <select class="usa-select usa-combo-box__select tmss-custom-select" name="options" id="move_date_time" formControlName="moveDateTime">
                @for (hr of this.listHrs; track hr) {
                  <option [value]="hr.key">{{hr.value}}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="delivery_date" class="usa-label">Delivery Date<abbr title="required"
                                                                          class="usa-hint usa-hint--required">*</abbr></label>
          <div class="grid-row">
            <div class="grid-col-8 mobile-lg:grid-col-8 tablet:grid-col-8 desktop:grid-col-8">
              <div class="usa-date-picker usa-date-picker--initialized" data-min-date="0000-01-01">
                <input class="usa-input usa-date-picker__internal-input" aria-labelledby="appointment-date-label"
                       aria-describedby="appointment-date-hint" aria-hidden="true" tabindex="-1" style="display: none;" >
                <div class="usa-date-picker__wrapper">
                  <input class="usa-input usa-date-picker__external-input" formControlName="requiredDeliveryDate"
                         id="delivery_date" name="delivery_date" aria-labelledby="delivery_date_label"
                         aria-describedby="delivery_date_hint" type="text" (change)="deliveryDateChange($event)">
                  <button type="button" class="usa-date-picker__button tmss-datepicker-custom" aria-haspopup="true"
                          aria-label="Toggle calendar"></button>
                  <div class="usa-date-picker__calendar" role="application" hidden=""></div>
                  <div class="usa-sr-only usa-date-picker__status" role="status" aria-live="polite"></div>
                </div>
              </div>
            </div>

            <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
              <select class="usa-select usa-combo-box__select tmss-custom-select" name="options" id="delivery_date_time" formControlName="requiredDeliveryDateTime">
                @for (hr of this.listHrs; track hr) {
                  <option [value]="hr.key">{{hr.value}}</option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label" for="move-date-comments">Pickup Comments:</label>
          <textarea id="move-date-comments" class="usa-textarea" maxlength="300" formControlName="moveDateComments"></textarea>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
          <label class="usa-label" for="delivery-date-comments">
            Delivery Comments:
          </label>
          <textarea id="delivery-date-comments" class="usa-textarea" maxlength="300" formControlName="deliveryDateComments"></textarea>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
          <label class="usa-label" for="notes">Additional Notes:
          </label>
          <textarea id="notes" class="usa-textarea" maxlength="500" formControlName="additionalNotes"></textarea>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
          <label class="usa-label text-bold">Enter origin, destination & other addresses</label>
          <button type="button" class="usa-button" (click)="enterAddressModal()" [disabled]="isAddressInvalid()">Addresses</button>
          @if (allAddressExist) {
            <span>
                <svg class="usa-icon define-valid-icon" aria-hidden="true" tooltip="Address info is completed." focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#check_circle"></use>
                </svg>
              </span>
          } @else {
            <span>
                <svg class="usa-icon define-invalid-icon" aria-hidden="true" focusable="false" role="img" tooltip="Incomplete Address info. Please enter all required fields.">
                  <use xlink:href="/assets/uswds/img/sprite.svg#cancel"></use>
                </svg>
              </span>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
          <label for="address" class="usa-label text-bold">Enter or edit package information</label>
          <button type="button" class="usa-button" (click)="openPackageModal()" id="address">Package Information</button>
          @if (packagesExist) {
            <span>
                <svg class="usa-icon define-valid-icon" aria-hidden="true" tooltip="Package info is completed." focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#check_circle"></use>
                </svg>
              </span>
          } @else {
            <span>
                <svg class="usa-icon define-invalid-icon" aria-hidden="true" focusable="false" role="img" tooltip="Incomplete Package info. Please enter all required fields.">
                  <use xlink:href="/assets/uswds/img/sprite.svg#cancel"></use>
                </svg>
              </span>
          }
        </div>
      </div>
      @if (addressDisplayItems.length) {
        <div class="grid-row grid-gap margin-top-2">
          @for (item of addressDisplayItems; track item.label) {
            <div class="grid-col-12 tablet:grid-col-6 desktop:grid-col-4 margin-bottom-2">
              <section class="border border-base-lighter padding-2 height-full">
                <h3 class="font-sans-md margin-0 margin-bottom-1">{{item.label}}</h3>
                @for (line of item.lines; track $index) {
                  <div class="font-sans-sm">{{line}}</div>
                }
              </section>
            </div>
          }
        </div>
      }
      @if (packageDisplayItems.length) {
        <div class="grid-row grid-gap margin-top-2">
          @for (item of packageDisplayItems; track item.label) {
            <div class="grid-col-12 tablet:grid-col-6 desktop:grid-col-4 margin-bottom-2">
              <section class="border border-base-lighter padding-2 height-full">
                <h3 class="font-sans-md margin-0 margin-bottom-1">{{item.label}}</h3>
                @for (line of item.lines; track $index) {
                  <div class="font-sans-sm">{{line}}</div>
                }
              </section>
            </div>
          }
        </div>
      }
      <div class="grid-row mt-4">
        <button type="button" class="usa-button" (click)="submit()">Submit</button>
      </div>
    </fieldset>
  </form>
</div>
